<template>
    <!-- 产品策略 -->
    <div class="productStrategy">
        <el-tabs v-model="activeSy" type="border-card" class="tabs-card-three">
            <el-tab-pane name="first" label="尽调报告">
                <div class="clearfix"><el-button type="built fr" @click="dialogVisible=true"><i class="el-icon-plus"></i>尽调报告</el-button></div>
                <el-table class="table-two mt20" :data="jdReportTable" border>
                    <el-table-column label="报告名称" prop="reportName" width="300px"></el-table-column>
                    <el-table-column label="报告类型" prop="type"></el-table-column>
                    <el-table-column label="添加时间" prop="addDate"></el-table-column>
                    <el-table-column label="操作" width="300px">
                        <template slot-scope="scope">
                            <span class="btn-normal" @click="editReport('jd',scope.row)">编辑</span>
                            <span class="btn-normal" @click="delReport('jd',scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    class="pagination-one mt20"
                    hide-on-single-page
                    background
                    :page-size="jdReport.pageNum"
                    :current-page="jdReport.page"
                    layout="prev, pager, next"
                    @current-change="jdCurrentChange"
                    :total="jdReport.total">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane name="second" label="回访报告">
                <div class="clearfix"><el-button type="built fr"><i class="el-icon-plus"></i>回访报告</el-button></div>
                <el-table class="table-two mt20" :data="hfReportTable" border>
                    <el-table-column label="名称" prop="reportName" width="300px"></el-table-column>
                    <el-table-column label="报告类型" prop="type"></el-table-column>
                    <el-table-column label="添加时间" prop="addDate"></el-table-column>
                    <el-table-column label="操作" width="300px">
                        <template slot-scope="scope">
                            <span class="btn-normal" @click="editReport('hf',scope.row)">编辑</span>
                            <span class="btn-normal" @click="delReport('jd',scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    class="pagination-one mt20"
                    hide-on-single-page
                    background
                    :page-size="hfReport.pageNum"
                    :current-page="hfReport.page"
                    layout="prev, pager, next"
                    @current-change="hfCurrentChange"
                    :total="hfReport.total">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
        <!-- 尽调报告 -->
        <el-dialog title="尽调报告" class="dialog-normal" :visible.sync="dialogVisible" @close="dialogVisible=false">
            <div class="point" id="scrollbox">
                <el-form class="form-info" ref="addFormRef" :model="addForm" :inline="true" label-position="right" label-width="140px">
                    <template v-if="reportStep=='1'">
                        <el-row class="row-two"><h3 class="title">尽调报告</h3></el-row>
                        <el-form-item label="报告名称" prop="researcher">
                            <el-input v-model="addForm.reportName"></el-input>
                        </el-form-item>
                        <el-row class="row-two"><h3 class="title">尽调报告人</h3></el-row>
                        <el-form-item label="研究员" prop="researcher">
                            <el-input v-model="addForm.researcher"></el-input>
                        </el-form-item>
                        <el-form-item label="风控" prop="riskControl">
                            <el-input v-model="addForm.riskControl"></el-input>
                        </el-form-item>
                        <el-form-item label="尽调时间" prop="time">
                            <el-date-picker style="width: 172px;" v-model="addForm.time" :editable="false" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="尽调方式" prop="way">
                            <el-select v-model="addForm.way" class="select-one">
                                <el-option label="线上" value="线上"></el-option>
                                <el-option label="现场" value="现场"></el-option>
                                <el-option label="拜访" value="拜访"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="addForm.way == '现场' || addForm.way == '拜访'" label="现场照片" prop="way">
                            <el-upload action :show-file-list="false" :on-progress="getSitePhotos" style="display: inline-block;">
                                <div class="upload-img"><img src="../../assets/images/upload.png" alt="">上传照片</div>
                            </el-upload>
                            <span class="ml20">{{addForm.wayImg}}</span>
                        </el-form-item>
                        <br>
                        <el-form-item label="尽调策略" prop="strategy">
                            <el-select v-model="addForm.strategy" class="select-one">
                                <el-option label="主观股票" value="主观股票"></el-option>
                                <el-option label="量化策略" value="量化策略"></el-option>
                                <el-option label="管理期货" value="管理期货"></el-option>
                                <el-option label="套利策略" value="套利策略"></el-option>
                                <el-option label="债券策略" value="债券策略"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="管理人名称" prop="managerName">
                            <el-autocomplete v-model="addForm.managerName" :fetch-suggestions="(queryString, cb) => {querySearchAsync(queryString, cb, '公司');}"  placeholder="请输入内容" @select="handleSelect">
                                <template slot-scope="{ item }">
                                    <div v-if="item.nodata=='无数据'" class="empty">{{ item.nodata }}</div>
                                    <span :title="item.secuNameAbbr">{{ item.secuNameAbbr }}</span>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                        <br>
                        <el-form-item label="名片" prop="businessCard">
                            <el-upload action :show-file-list="false" :on-progress="getBusinessCard" style="display: inline-block;">
                                <div class="upload-img"><img src="../../assets/images/upload.png" alt="">上传名片</div>
                            </el-upload>
                            <span class="ml20">{{addForm.businessCardImg}}</span>
                        </el-form-item>
                        <el-row class="row-two"><h3 class="title">接待人员</h3></el-row>
                        <el-form-item label="姓名" prop="receptionName">
                            <el-input v-model="addForm.receptionName"></el-input>
                        </el-form-item>
                        <el-form-item label="职务" prop="receptionDuties">
                            <el-select v-model="addForm.receptionDuties" class="select-one">
                                <el-option label="合伙人" value="合伙人"></el-option>
                                <el-option label="投资总监" value="投资总监"></el-option>
                                <el-option label="基金经理" value="基金经理"></el-option>
                                <el-option label="研究员" value="研究员"></el-option>
                                <el-option label="市场总监" value="市场总监"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="receptionContact">
                            <el-input v-model="addForm.receptionContact"></el-input>
                        </el-form-item>
                        <el-row class="row-two"><h3 class="title">管理人基本信息</h3></el-row>
                        <el-form-item label="成立时间">
                            <span>{{managerInfo.establishmentDate}}</span>
                        </el-form-item>
                        <el-form-item label="登记时间">
                            <span>{{managerInfo.registrationTime}}</span>
                        </el-form-item>
                        <el-form-item label="注册资本">
                            <span>{{managerInfo.regCapital}} 万</span>
                        </el-form-item>
                        <el-form-item label="实缴资本">
                            <span>{{managerInfo.actulCapital}} 万</span>
                        </el-form-item>
                        <br>
                        <el-form-item label="注册地点" prop="registeredOffice">
                            <el-input v-model="addForm.registeredOffice"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="办公地点" prop="officeLocation">
                            <el-input v-model="addForm.officeLocation"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="总规模" prop="overallScope">
                            <el-input v-model="addForm.overallScope"><span slot="suffix" class="el-input__icon">亿</span></el-input>
                        </el-form-item>
                        <el-form-item label="规模(金方数据库)" prop="jfScope">
                            <span>{{managerInfo.assetRange}} 亿</span>
                        </el-form-item>
                        <br>
                        <el-form-item label="产品数量" prop="productCount">
                            <el-input v-model="addForm.productCount"><span slot="suffix" class="el-input__icon">只</span></el-input>
                        </el-form-item>
                        <el-form-item label="数量(金方数据库)" prop="jfCount">
                            <span>{{managerInfo.fundCount}} 只</span>
                        </el-form-item>
                        <el-form-item label="资金来源" prop="fundsSource">
                            <el-input v-model="addForm.fundsSource" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub clearfix">
                            <span class="fl">主策略及规模</span>
                            <el-dropdown trigger="click" class="fr" @command="addHandleCommand">
                                <span class="el-dropdown-link">
                                    添加<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="item" v-for="(item,i) in strategyScale" :key="i+'ss'">{{item}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-row>
                        <el-form-item v-for="(item,i) in addForm.strategyScaleArr" :key="i+'zclgm'" :label="item.StrategyName" prop="quantization">
                            <div class="dialog-normal-list">
                                <el-input v-model="addForm.StrategyCount"><span slot="suffix" class="el-input__icon">亿</span></el-input>
                                <span class="del" @click="addForm.strategyScaleArr.splice(i,1)"><i class="el-icon-remove"></i></span>
                            </div>
                        </el-form-item>
                        <el-form-item label="内容" prop="strategyCon">
                            <el-input v-model="addForm.strategyCon" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub clearfix">
                            <span class="fl">产品线及规模</span>
                            <el-dropdown trigger="click" class="fr" @command="addScaleCommand">
                                <span class="el-dropdown-link">
                                    添加<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="item" v-for="(item,i) in productLineScale" :key="i+'pls'">{{item}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-row>
                        <el-form-item v-for="(item,i) in addForm.productLineScaleArr" :key="i+'zpxgm'" :label="item.ProductName">
                            <div class="dialog-normal-list">
                                <el-input v-model="item.ProductCount"><span slot="suffix" class="el-input__icon">亿</span></el-input>
                                <span class="del" @click="addForm.productLineScaleArr.splice(i,1)"><i class="el-icon-remove"></i></span>
                            </div>
                        </el-form-item>
                        <el-form-item label="内容">
                            <el-input v-model="addForm.productLineScale" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <el-form-item label="策略代表产品" prop="representsProduct">
                            <el-autocomplete v-model="addForm.representsProduct" :fetch-suggestions="(queryString, cb) => {querySearchAsync(queryString, cb, '产品');}"  placeholder="请输入内容" @select="productSelect">
                                <template slot-scope="{ item }">
                                    <div v-if="item.nodata=='无数据'" class="empty">{{ item.nodata }}</div>
                                    <span :title="item.secuNameAbbr">{{ item.secuNameAbbr }}</span>
                                </template>
                            </el-autocomplete>
                            <img class="dialog-normal-img mt20" :src="addForm.representsProductImg" alt="">
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub">公司员工</el-row>
                        <el-form-item label="员工总人数" prop="staffNum">
                            <el-input v-model="addForm.staffNum"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="核心投研人员" prop="investmentResearch">
                            <el-input v-model="addForm.investmentResearch"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="核心高管" prop="seniorExecutive">
                            <el-input v-model="addForm.seniorExecutive"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="基金经理" prop="fundManager">
                            <el-input v-model="addForm.fundManager"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="研究员" prop="staffResearcher">
                            <el-input v-model="addForm.staffResearcher"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="IT" prop="it">
                            <el-input v-model="addForm.it"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="交易员" prop="trader">
                            <el-input v-model="addForm.trader"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="风控" prop="staffRiskControl">
                            <el-input v-model="addForm.staffRiskControl"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="市场" prop="market">
                            <el-input v-model="addForm.market"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="其他" prop="other">
                            <el-input v-model="addForm.other"><span slot="suffix" class="el-input__icon">人</span></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="staffCon">
                            <el-input v-model="addForm.staffCon" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub">核心投研人员简历</el-row>
                        <el-form-item label="内容" prop="investmentResearchResume">
                            <el-input v-model="addForm.investmentResearchResume" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub">IT硬件投入（量化策略）</el-row>
                        <el-form-item label="已累计投入" prop="accumulatedInvestment">
                            <el-input v-model="addForm.accumulatedInvestment"><span slot="suffix" class="el-input__icon">亿</span></el-input>
                        </el-form-item>
                        <el-form-item label="每年预算投入" prop="annualBudgetInvestment">
                            <el-input v-model="addForm.annualBudgetInvestment"><span slot="suffix" class="el-input__icon">万</span></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="itHardwareInvestment">
                            <el-input v-model="addForm.itHardwareInvestment" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub clearfix">
                            <span class="fl">公司股权情况</span>
                            <span class="fr" @click="addShareholding">添加<i class="el-icon-circle-plus" style="margin-left: 5px;"></i></span>
                        </el-row>
                        <el-form-item label="股权">
                            <div class="dialog-normal-list" v-for="(hold,h1) in addForm.shareholdingLists" :key="h1+'gq'">
                                <el-input v-model="hold.Name"></el-input>
                                <el-input v-model="hold.ShareRatio" class="ml20"><span slot="suffix" class="el-input__icon">%</span></el-input>
                                <span class="del" @click="delShareholding(h1)"><i class="el-icon-remove"></i></span>
                            </div>
                        </el-form-item>
                        <el-form-item label="内容" prop="shareholdingCon">
                            <el-input v-model="addForm.shareholdingCon" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub">其他信息</el-row>
                        <el-form-item label="内容" prop="otherMessage">
                            <el-input v-model="addForm.otherMessage" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                    </template>
                    <template v-if="reportStep=='2' && addForm.strategy=='主观股票'">
                        <el-row class="row-two"><h3 class="title">主观策略、组合与产品</h3></el-row>
                        <el-row class="row-sub">投资策略</el-row>
                        <el-form-item label="策略类型" prop="policyType">
                            <el-radio-group v-model="addForm.policyType">
                                <el-radio label="价值">价值</el-radio>
                                <el-radio label="成长">成长</el-radio>
                                <el-radio label="择时">择时</el-radio>
                                <el-radio label="轮动">轮动</el-radio>
                                <el-radio label="均衡">均衡</el-radio>
                                <el-radio label="事件驱动">事件驱动</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="策略描述" prop="policyDescription">
                            <el-input v-model="addForm.policyDescription" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub">投资组合</el-row>
                        <el-form-item label="投资标的" prop="investmentPortfolio">
                            <el-radio-group v-model="addForm.investmentPortfolio">
                                <el-radio label="A股">A股</el-radio>
                                <el-radio label="港股">港股</el-radio>
                                <el-radio label="美股">美股</el-radio>
                                <el-radio label="其他">其他</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <br>
                        <el-form-item label="持仓数量" prop="holdNum1">
                            <el-input v-model="addForm.holdNum1" style="width: 90px;"></el-input> ～ 
                        </el-form-item>
                        <el-form-item prop="holdNum2">
                            <el-input v-model="addForm.holdNum2" style="width: 90px;"></el-input> 只
                        </el-form-item>
                        <br>
                        <el-form-item label="行业集中度上限" prop="upperLimit">
                            <el-input v-model="addForm.upperLimit"></el-input>
                        </el-form-item>
                        <el-form-item label="个股集中度上限" prop="lowerLimit">
                            <el-input v-model="addForm.lowerLimit"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="是否用衍生品" prop="derivative">
                            <el-radio-group v-model="addForm.derivative">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                                <el-radio label="偶尔">偶尔</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <br>
                        <el-form-item label="仓位" prop="position1">
                            <el-input v-model="addForm.position1" style="width: 90px;"></el-input> ～ 
                        </el-form-item>
                        <el-form-item prop="position2">
                            <el-input v-model="addForm.position2" style="width: 90px;"></el-input> %
                        </el-form-item>
                        <br>
                        <el-form-item label="换手率" prop="turnoverRate">
                            <el-input v-model="addForm.turnoverRate"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="持仓行业" prop="holdingIndustry">
                            <el-input v-model="addForm.holdingIndustry"></el-input>
                        </el-form-item>
                        <el-form-item label="组合描述" prop="description">
                            <el-input v-model="addForm.description" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub">风险管控</el-row>
                        <el-form-item label="事前风控" prop="priorRiskControl">
                            <el-input v-model="addForm.priorRiskControl" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <el-form-item label="事中风控" prop="strokeControl">
                            <el-input v-model="addForm.strokeControl" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <el-form-item label="事后风控" prop="afterRiskControl">
                            <el-input v-model="addForm.afterRiskControl" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                        <div class="line"></div>
                        <el-row class="row-sub">代表产品</el-row>
                        <el-form-item label="策略代表产品" prop="strategyRepresentsProduct">
                            <el-autocomplete v-model="addForm.strategyRepresentsProduct" :fetch-suggestions="(queryString, cb) => {querySearchAsync(queryString, cb, '产品');}"  placeholder="请输入内容">
                                <template slot-scope="{ item }">
                                    <div v-if="item.nodata=='无数据'" class="empty">{{ item.nodata }}</div>
                                    <span :title="item.secuNameAbbr">{{ item.secuNameAbbr }}</span>
                                </template>
                            </el-autocomplete>
                            <img class="dialog-normal-img mt20" :src="addForm.strategyRepresentsProductImg" alt="">
                        </el-form-item>
                        <el-form-item label="产品介绍" prop="representativeProducts">
                            <el-input v-model="addForm.representativeProducts" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                    </template>
                    <template v-if="reportStep=='3'">
                        <el-row class="row-two"><h3 class="title">研究员观点</h3></el-row>
                        <el-form-item label="公司评价" prop="companyEvaluate">
                            <div class="dialog-normal-list">
                                <el-rate :value="addForm.companyEvaluate/2" disabled></el-rate>
                                <el-input v-model="addForm.companyEvaluate" style="width: 90px;"></el-input>
                            </div>
                        </el-form-item>
                        <br>
                        <el-form-item label="团队评价" prop="teamEvaluation">
                            <div class="dialog-normal-list">
                                <el-rate :value="addForm.teamEvaluation/2" disabled></el-rate>
                                <el-input v-model="addForm.teamEvaluation" style="width: 90px;"></el-input>
                            </div>
                        </el-form-item>
                        <br>
                        <el-form-item label="策略评价" prop="strategyEvaluation">
                            <div class="dialog-normal-list">
                                <el-rate :value="addForm.strategyEvaluation/2" disabled></el-rate>
                                <el-input v-model="addForm.strategyEvaluation" style="width: 90px;"></el-input>
                            </div>
                        </el-form-item>
                        <br>
                        <el-form-item label="风控评价" prop="riskControlEvaluation">
                            <div class="dialog-normal-list">
                                <el-rate :value="addForm.riskControlEvaluation/2" disabled></el-rate>
                                <el-input v-model="addForm.riskControlEvaluation" style="width: 90px;"></el-input>
                            </div>
                        </el-form-item>
                        <br>
                        <el-form-item label="业绩评价" prop="performanceEvaluation">
                            <div class="dialog-normal-list">
                                <el-rate :value="addForm.performanceEvaluation/2" disabled></el-rate>
                                <el-input v-model="addForm.performanceEvaluation" style="width: 90px;"></el-input>
                            </div>
                        </el-form-item>
                        <br>
                        <el-form-item label="是否有额度" prop="limit">
                            <el-radio-group v-model="addForm.limit">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </el-form-item><br>
                        <el-form-item label="是否愿意签代销" prop="consignment">
                            <el-radio-group v-model="addForm.consignment">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </el-form-item><br>
                        <el-form-item label="是否推荐入池" prop="enterPool">
                            <el-radio-group v-model="addForm.enterPool">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </el-form-item><br>
                        <el-form-item label="观点描述" prop="viewDescription">
                            <el-input v-model="addForm.viewDescription" type="textarea" resize="none" :rows="6"></el-input>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div slot="footer" class="point-footer">
                <el-button type="normal" @click="dialogVisible=false">保存</el-button>
                <el-button v-if="reportStep=='1'" type="normal" @click="next('2')">下一步</el-button>
                <div v-if="reportStep=='2'">
                    <el-button type="normal" @click="next('1')">上一步</el-button>
                    <el-button type="normal" @click="next('3')">下一步</el-button>
                </div>
                <div v-if="reportStep=='3'">
                    <el-button type="normal" @click="next('2')">上一步</el-button>
                    <el-button type="normal" @click="dialogVisible=false">提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "productStrategy",
    data() {
        return {
            activeSy: 'first',
            jdReportTable: [],
            jdReport: {
                page: 1,
                pageNum: 10,
                total: 0
            },
            hfReportTable: [
                {
                    reportID: '',
                    reportName: '回访报告1',
                    addDate: '2023-06-15',
                    type: 'manager',
                }
            ],
            hfReport: {
                page: 1,
                pageNum: 10,
                total: 0
            },
            dialogVisible: false,
            // 添加
            addForm: {
                strategy: '主观股票',
                wayImg: '',
                businessCardImg: '',
                productLineScales: [],
                strategyScaleArr: [],
                productLineScaleArr: [],
                shareholdingLists: [//股权
                    {
                        Name: '', 
                        ShareRatio: '', 
                    },
                ],
                companyEvaluate: 3.7,
                teamEvaluation: 3.7,
                strategyEvaluation: 3.7,
                riskControlEvaluation: 3.7,
                performanceEvaluation: 3.7,
            },
            reportStep: '1',
            strategyScale: ['主观多头','股票多空','量化指增','量化选股','股票市场中性','套利策略','CTA策略','商品套利策略','期权套利策略','期权策略','债券策略'],
            productLineScale: ['多策略产品','股票多头','300指增','500指增','1000指增','量化选股','市场中性产品','CTA产品','商品套利','期权产品'],
            managerInfo: {
                establishmentDate: '--',//成立时间
                registrationTime: '--',//登记时间
                regCapital: '--',//注册资本
                actulCapital: '--',//实缴资本
                assetRange: '--',//规模
                fundCount: '--',//数量
            }
            
        }
    },
    mounted() {
        this.getReportList()
    },
    methods: {
        getReportList() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetReportList,{
                Page: vm.jdReport.page,
                PageNum: vm.jdReport.pageNum,
            }).then(res => {
                // console.log(res);
                if(res.data.code == 200) {
                    vm.jdReportTable = res.data.data.dataList
                    vm.jdReport.total = res.data.data.pageCount
                }
            }).catch(err => {})
        },
        jdCurrentChange(newPage) {
            this.jdReport.page = newPage
            this.getReportList()
        },
        hfCurrentChange(newPage) {
            this.hfReport.page = newPage
        },
        // 编辑
        editReport(type,scope) {
            
        },
        // 删除
        delReport(type,scope) {
            let vm = this
            vm.$confirm('要删除“'+scope.reportName+'”吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(type == 'jd') {
                    vm.$message.success('删除成功!')
                }
            }).catch(err=>{})
        },
        // 上/下一步
        next(val) {
            this.reportStep = val
            document.getElementById('scrollbox').scrollTo({top: 0})
        },
        // 主策略及规模
        addHandleCommand(command) {
            for(let i = 0; i < this.addForm.strategyScaleArr.length; i++) {
                if(this.addForm.strategyScaleArr[i].StrategyName == command) {
                    return;
                }
            }
            this.addForm.strategyScaleArr.push({
                StrategyName: command,
                StrategyCount: '',
            })
        },
        // 产品线及规模
        addScaleCommand(command) {
            for(let i = 0; i < this.addForm.productLineScaleArr.length; i++) {
                if(this.addForm.productLineScaleArr[i].ProductName == command) {
                    return;
                }
            }
            this.addForm.productLineScaleArr.push({
                ProductName: command,
                ProductCount: '',
            })
        },
        // 检索产品/公司
        querySearchAsync(query, cb , type) {
            let vm = this
            if (query !== '') {
                this.key = query
                this.$http.post(this.$apiPath.getFuzzySeachResult, {
                    innerType: type, //内部类型
                    KeyWords: query //模糊查询关键词
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == 200) {
                        let restaurants = res.data.data.dataList;
                        if (restaurants.length > 0) {
                            cb(restaurants);
                        } else {
                            cb([{nodata:'无数据'}]);
                        }
                    }
                })
            } else {
                cb([]);
                vm.managerInfo = {
                    establishmentDate: '--',
                    registrationTime: '--',
                    regCapital: '--',
                    actulCapital: '--',
                    assetRange: '--',
                    fundCount: '--',
                }
            }
        },
        // 管理人检索
        handleSelect(val) {
            let vm = this
            if(val.nodata != '无数据') {
                vm.addForm.managerName = val.secuNameAbbr
                vm.$http.post(vm.$apiPath.GetPrivateFirmInfo,{
                    InnerCode: val.innerCode
                }).then(res => {
                    console.log(res);
                    if(res.data.code == 200) {
                        let xdata = res.data.data
                        vm.managerInfo = {
                            establishmentDate: xdata.establishmentDate,//成立时间
                            registrationTime: xdata.registrationTime,//登记时间
                            regCapital: xdata.regCapital,//注册资本
                            actulCapital: xdata.actulCapital,//实缴资本
                            assetRange: xdata.assetRange,//规模
                            fundCount: xdata.fundCount,//数量
                        }
                    }
                
                }).catch(err => {})
            }
        },
        // 策略代表产品检索
        productSelect(val) {
            let vm = this
            if(val.nodata != '无数据') {
                vm.addForm.representsProduct = val.secuNameAbbr
                vm.addForm.representsProductImg = 'https://www.myfund.com/images/index/zd_banner.png'
            }
        },
        // 现场照片
        getSitePhotos(event, file, fileList) {
            let vm = this
            vm.addForm.wayImg = file.name
            console.log(file);
            vm.$commonJs.getBase64(file.raw).then(result => {
                // console.log(result);
            });
            return
        },
        // 上传名片
        getBusinessCard (event, file, fileList) {
            let vm = this
            vm.addForm.businessCardImg = file.name
            vm.$commonJs.getBase64(file.raw).then(result => {
                // console.log(result);
            });
            return
        },
        // 股东
        addShareholding() {
            this.addForm.shareholdingLists.push(
                {
                    Name: '', 
                    ShareRatio: '', 
                }
            )
        },
        delShareholding(i) {
            this.addForm.shareholdingLists.splice(i,1)
        }
    }
}
</script>

<style lang="less" scoped>
.productStrategy {
    .dialog-normal {
        /deep/.el-dialog__body {padding: 0;}
        .point {
            overflow-y: scroll;padding: 30px 126px 0;height: 437px;box-sizing: border-box;
            .form-info {
                display: inline-block;
                .el-form-item {
                    margin-bottom: 5px;
                    /deep/.el-form-item__content {height: auto;}
                    /deep/.el-form-item__label {font-size: 14px!important;}// text-align-last: justify;
                    /deep/.el-input__inner {max-width: 150px;}
                }
            }
            .el-textarea /deep/.el-textarea__inner {font-size: 16px;border: 1px solid @borderColor;margin: 8px 0;width: 750px;}
            .upload-normal {
                padding: 26px;
                /deep/.el-upload-list__item,/deep/.el-upload--picture-card {width: 74px;height: 74px;line-height: 74px; border: none;}
            }
            .el-radio-group {
                /deep/.el-radio__inner {background: @whiteColor;}
                /deep/.el-radio__label{font-size: 14px;;}
            }
        }
        .row-two {margin: 30px 0;height: 35px; border-bottom: 1px solid @borderColor;}
        .row-sub {
            font-weight: bold;font-size: 16px;margin: 25px 0;color: @color3;
            .fr {cursor: pointer;font-weight: normal;font-size: 14px;}
        }
        .line {border-bottom: 1px dashed @borderColor;margin: 30px 0;}
        .label-w {margin-left: 140px;}
        .upload-img {
            color: @mainColor;
            img {margin-right: 5px;vertical-align: text-top;}
        }
        &-list {
            display: flex;align-items: center;
            .del {margin-left: 15px;cursor: pointer;}
        }
        &-img {display: block;width: 400px;}
    }
    .row-one-select {
        /deep/.el-input {height:26px;line-height: 26px;}
        /deep/.el-input__inner {height: 26px;line-height: 26px;border-color: @mainColor;color: @mainColor;text-align: center;}
        /deep/.el-select__caret:before {
            content: "";
            background: url(../../assets/images/select_down_b.png) center center no-repeat;
            position: absolute;
            width: 100%;
            height: 100%;
            transform: rotate(180deg);
            top: 0%;
            right: 0%;
        }
    }
}
</style>